<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋問答" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </template>
    <template slot="right">
      <el-button @click="onCreate" style="margin-right: 20px;">新增QA</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="分類" min-width="150px">
          <template slot-scope="scope">
            {{getGroupTitle(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="問題" min-width="150px">
          <template slot-scope="scope">
            {{scope.row.QuestionTw}}
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="languages.includes('Cn')" label="簡中" min-width="120px">
          <template slot-scope="scope">
            {{scope.row.QuestionCn}}
          </template>
        </el-table-column>
        <el-table-column v-if="languages.includes('En')" label="英文" min-width="120px">
          <template slot-scope="scope">
            {{scope.row.QuestionEn}}
          </template>
        </el-table-column>
        <el-table-column v-if="languages.includes('Jp')" label="日文" min-width="120px">
          <template slot-scope="scope">
            {{scope.row.QuestionJp}}
          </template>
        </el-table-column> -->
        <el-table-column label="權重" width="50px">
          <template slot-scope="scope">
            <p style="text-align: right;">{{scope.row.Weigh}}</p>
          </template>
        </el-table-column>
        <el-table-column label="置頂" width="50px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsTop" class="deployed" style="text-align: center;">✓</p>
            <p v-else class="draft"></p>
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="onUpdate(scope.row)">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <q-a-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import QAEditorModal from '@/data/qa/view/editor-modal.vue'
// svgs
import '@/assets/svgs/index.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    QAEditorModal
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {},
  methods: {
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.qa.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        var group = this.getGroup(o)
        if (group && group.TitleTw && group.TitleTw.includes(this.keyword)) return true
        if (group && group.TitleCn && group.TitleCn.includes(this.keyword)) return true
        if (group && group.TitleEn && group.TitleEn.includes(this.keyword)) return true
        if (group && group.TitleJp && group.TitleJp.includes(this.keyword)) return true
        if (o.QuestionTw && o.QuestionTw.includes(this.keyword)) return true
        if (o.QuestionCn && o.QuestionCn.includes(this.keyword)) return true
        if (o.QuestionEn && o.QuestionEn.includes(this.keyword)) return true
        if (o.QuestionJp && o.QuestionJp.includes(this.keyword)) return true
        if (o.AnswerTw && o.AnswerTw.includes(this.keyword)) return true
        if (o.AnswerCn && o.AnswerCn.includes(this.keyword)) return true
        if (o.AnswerEn && o.AnswerEn.includes(this.keyword)) return true
        if (o.AnswerJp && o.AnswerJp.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.qa.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.QuestionTw}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.qa.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.qa.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.qa.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    getGroup (qa) {
      if (qa.group) return qa.group
      qa.group = this.$store.state.qaGroup.list.find(o => o.ID === qa.GroupID) || {}
      return qa.group
    },
    getGroupTitle (qa) {
      return this.getGroup(qa).TitleTw
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.qa.list
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    // query...
    let promise1 = this.$services.qaGroup.getAll(this).then(res => {
      this.$store.state.qaGroup.list = res.data.result
    })
    let promise2 = this.$services.qa.getAll(this).then(res => {
      this.$store.state.qa.list = res.data.result
    })

    Promise.all([promise1, promise2]).then(res => {
      initTableData()
    }).catch(this.$handleServiceError)
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
